<template>
    <div>
        <div class="dialog-footer" style="text-align: right;margin-bottom: 10px">
            <el-button size="small" type="danger" @click="saveActiveConfig('active')">
                {{active.activeNo == '' ? '下一步' : '保 存'}}
            </el-button>
        </div>
        <el-form :model="active" :rules="rules" label-width="160px">
            <el-form-item label="注意">
                <el-alert title="活动创建完后默认是下线状态，请点击上线按钮，若有配置错误会提示配置出错信息，无错误会执行上线操作." type="warning" :closable="false">
                </el-alert>
            </el-form-item>
            <el-form-item label="活动号" v-show="false">
                <el-input v-model="active.activeNo" placeholder="活动号"></el-input>
            </el-form-item>
            <el-form-item label="bindCode" v-show="false">
                <el-input v-model="active.bindCode" placeholder="bindCode"></el-input>
            </el-form-item>
            <el-form-item label="活动名称" prop="activeName">
                <el-input v-model="active.activeName" placeholder="活动名称"></el-input>
            </el-form-item>
            <el-form-item label="活动类型" prop="activeType">
                <el-select v-model="active.activeType" clearable filterable placeholder="请选择活动类型"
                           @change="changeActiveType">
                    <el-option
                            v-for="item in activeTypeList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="产品类目" v-show="active.activeType==22" prop="categoryId">
                <el-select v-model="active.categoryId" clearable filterable placeholder="产品类目"
                           @change="changeCategoryId">
                    <el-option
                            v-for="item in productCategoryIds"
                            :key="item.key"
                            :label="item.value"
                            :value="item.key">
                    </el-option>
                </el-select>
                <span type="success">限制已购买当前选择品类的用户参与</span>
            </el-form-item>


            <el-form-item label="渠道类型" v-show="false" prop="tjType">
                <el-select v-model="active.tjType" clearable filterable placeholder="请选择渠道类型">
                    <el-option
                            v-for="item in tjTypeList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="城市" v-show="active.showCity" prop="cityId">
                <el-select v-model="active.cityId" clearable filterable placeholder="请选择城市">
                    <el-option
                            v-for="item in cityList"
                            :key="item.cityId"
                            :label="item.cityName"
                            :value="item.cityId">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="所属部门" v-show="false" prop="deptId">
                <el-select v-model="active.deptId" clearable filterable placeholder="所属部门">
                    <el-option
                            v-for="item in depList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="默认关键字" prop="keywordId">
                <el-select v-model="active.keywordId" clearable filterable placeholder="请选择默认关键字">
                    <el-option
                            v-for="item in keywordList"
                            :key="item.id"
                            :label="item.keyword"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="支付成功推送" prop="payKeywordId">
                <el-select v-model="active.payKeywordId" clearable filterable placeholder="请选择支付成功推送">
                    <el-option
                            v-for="item in keywordList"
                            :key="item.id"
                            :label="item.keyword"
                            :value="item.id">
                    </el-option>
                </el-select>
                <span type="success">活动订单支付时给用户推送客服消息</span>
            </el-form-item>
            <el-form-item label="支付成功推送(SMS)" prop="paySmsKeywordId">
                <el-select v-model="active.paySmsKeywordId" clearable filterable placeholder="请选择支付成功推送(SMS)">
                    <el-option
                            v-for="item in keywordList"
                            :key="item.id"
                            :label="item.keyword"
                            :value="item.id">
                    </el-option>
                </el-select>
                <span type="success">活动订单支付时给用户推送短信</span>
            </el-form-item>
            <el-form-item label="活动邀请人数" prop="inviteNum" v-show="showInviteNum">
                <el-input-number v-model="active.inviteNum" :min="0" :max="100"
                                 placeholder="0 邀请数"></el-input-number>
            </el-form-item>

            <el-form-item label="开始时间" prop="beginTime">
                <el-date-picker
                        v-model="active.beginTime"
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择活动开始时间">
                </el-date-picker>
            </el-form-item>

            <el-form-item label="结束时间" prop="endTime">
                <el-date-picker
                        v-model="active.endTime"
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择活动结束时间">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="邀请用户类型" v-show="showJoinNum" prop="joinNum">
                <el-select v-model="active.joinNum" clearable filterable placeholder="邀请用户类型 新用户和所有用户"
                           @change="changeActiveType">
                    <el-option
                            v-for="item in joinUserList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="到计时">
                <el-select v-model="active.countdown" placeholder="是否展示到计时">
                    <el-option v-for="item in countdownList"
                               :key="item.id"
                               :label="item.name"
                               :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="同一连接限制领取次数" v-show="active.activeType==15">
                <el-select v-model="cashTakeTypeProperty.propertyValue" placeholder="同一用户同一连接限制领取">
                    <el-option v-for="item in cashTackTypeList"
                               :key="item.id"
                               :label="item.name"
                               :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="是否自动生成周期活动">

                <el-select v-model="active.isPeriod">
                    <el-option
                            v-for="item in isPeriodList"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value">
                    </el-option>
                </el-select>

                <span style="padding: 20px;color: #795da3">如果选择是，系统自动按照设置的开始结束时间，自动生成下个周期的活动</span>
            </el-form-item>
            <el-form-item label="选择父级活动" v-show="active.activeType==27">
                <el-select v-model="active.parentBindCode"
                           filterable
                           clearable
                           remote
                           :remote-method="initActiveList"
                           placeholder="输入活动名称查询">
                    <el-option v-for="item in activeList"
                               :key="item.bindCode"
                               :label="item.activeName"
                               :value="item.bindCode">
                    </el-option>
                </el-select>
                <span style="padding: 20px;color: #795da3">父级活动相同的活动奶卡会展示在一起</span>
            </el-form-item>

            <el-form-item label="备注" prop="remark">
                <el-input v-model="active.remark" placeholder="备注"></el-input>
            </el-form-item>

        </el-form>
    </div>


</template>
<script>
    //导入 HTTP请求方法
    import {
        getEnableallCityList, getKeywordsOption,
        getValidDictionaryList,
        saveActive,
        getActive, getActiveList, saveActivePropertyApi,
    } from '../../api/api';

    import ElDialog from "../../../node_modules/element-ui/packages/dialog/src/component";
    export default {
        components: {ElDialog}, data() {
            var validateDate = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请选择日期'));
                } else if (value <= this.active.beginTime) {
                    callback(new Error('结束日期不能小于开始日期!'));
                } else {
                    callback();
                }
            };
            var validateDate2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请选择日期'));
                } else if (value >= this.active.endTime) {
                    callback(new Error('结束日期不能小于开始日期!'));
                } else {
                    callback();
                }
            };

            return {
                rules: {
                    activeName: [
                        {required: true, message: '请输入活动名称', trigger: 'blur'},
                        {min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur'}
                    ],
                    beginTime: [
                        {type: 'string', required: true, message: '请选择日期', trigger: 'change'}
                    ],
                    endTime: [
                        {type: 'string', required: true, message: '请选择结束日期', trigger: 'change'},
                        {validator: validateDate, trigger: 'blur'}
                    ],
                    inviteNum: [
                        {type: 'number', message: '必须为数字'}
                    ],
                    joinNum: [
                        {required: true, message: '请输参团人数', trigger: 'blur'},
                        {min: 1, max: 10, message: '参团人数在1-10之间', trigger: 'blur'}
                    ],
                    grouponHour: [
                        {required: true, message: '拼团超时时间', trigger: 'blur'},
                        {min: 1, max: 48, message: '拼团超时时间在1-48小时之间', trigger: 'blur'}
                    ],
                    activeUrl: [
                        {required: true, message: '必须输入连接地址', trigger: 'blur'},
                        {min: 1, max: 256, message: '长度在 5 到 60 个字符', trigger: 'blur'}
                    ],
                    activeContent: [
                        {min: 1, max: 500, message: '长度在 5 到 60 个字符', trigger: 'blur'}
                    ]
                },
                active: {
                    activeNo: this.$route.query.activeNo,
                    activeName: '',
                    tjType: 1,
                    deptId: 9,
                    status: 0,
                    beginTime: '',
                    endTime: '',
                    createTime: '',
                    payamount: 0,
                    bindCode: '',
                    activeType: 0,
                    cityId: 0,
                    keywordId: 0,
                    payKeywordId: 0,
                    paySmskeywordId: 0,
                    vipRightType: '',
                    platformId: 1,
                    platformGroupId: 1000,
                    inviteNum: 0,
                    joinNum: 0,
                    categoryId: '',
                    showCity: false,
                    isPeriod: 0,
                    remark: ''
                },
                keywordList: [],//关键字列表
                activeList: [],
                countdownList: [{id: 0, name: '否'}, {id: 1, name: '是'}],
                activeForm: {
                    activeName: "",
                    activeType: '',
                    currentPage: 1,
                    pageSize: 20,
                    status: 1
                },
                productCategoryIds: [{
                    key: "0",
                    value: "请选择"
                }, {
                    key: "1",
                    value: "希腊酸奶"
                }, {
                    key: "16",
                    value: "希腊酸奶-135g"
                }, {
                    key: "17",
                    value: "希腊酸奶-N300"
                }, {
                    key: "18",
                    value: "希腊酸奶-500g"
                }, {
                    key: "2",
                    value: "饮用型酸奶"
                }, {
                    key: "13",
                    value: "饮用型酸奶-纤酵"
                }, {
                    key: "14",
                    value: "饮用型酸奶-限糖打卡"
                }, {
                    key: "3",
                    value: "烘焙"
                }, {
                    key: "19",
                    value: "烘焙-低温"
                }, {
                    key: "20",
                    value: "烘焙-常温"
                }, {
                    key: "4",
                    value: "诚实全餐"
                }, {
                    key: "5",
                    value: "燕麦乐纯"
                }, {
                    key: "15",
                    value: "燕麦乐纯-燕麦粥"
                }, {
                    key: "6",
                    value: "燕麦福利社"
                }, {
                    key: "7",
                    value: "零食"
                }, {
                    key: "8",
                    value: "咖啡"
                }, {
                    key: "9",
                    value: "优惠券"
                }, {
                    key: "10",
                    value: "储值卡"
                }, {
                    key: "11",
                    value: "随箱辅料"
                }, {
                    key: "21",
                    value: "水牛奶"
                }, {
                    key: "12",
                    value: "其他"
                }],
                cityList: [{
                    ac: "000",
                    cityId: 0,
                    cityName: "全国",
                    firstPinyin: "a",
                    openCityStatus: 0,
                    ordinaryStatus: 1,
                    provinceId: "000",
                    status: 1
                }],//城市列表
                depList: [{id: 3, name: '用户推广中心'}, {id: 9, name: '用户运营'}],//部门列表
                isPeriodList: [{value: 0, name: '否'}, {value: 1, name: '是'}, {value: 2, name: '已生成'}],
                activeTypeList: [],
                activeStatusList: [{id: 1, name: '已上线'}, {id: 0, name: '已下线'}],
                cashTackTypeList: [{id: "仅一次", name: '仅一次'}, {id: "无限制", name: '无限制'}],
                showInviteNum: false,
                showJoinNum: false,
                cashTakeTypeProperty: {
                    propertyName: '仅领取一次',
                    propertyValue: "无限制",
                    propertyRemark: '同一连接是否设置为仅领取一次',
                    propertyId: '',
                    propertyKey: 'cashTakeType',
                    status: 1,
                    bindCode: ''
                },
                joinUserList: [{id: 1, name: '仅新用户'}, {id: 0, name: '所有用户'}],
                activeProperty: {
                    propertyId: '',
                    bindCode: '',
                    propertyName: 'category',
                    propertyValue: '',
                    propertyRemark: '活动限售品类',
                    status: 1
                },
                //活动统计列表
                tjTypeList: [{id: 0, name: '普通'},
                    {id: 1, name: 'KOL'},
                    {id: 2, name: '乐纯12问'},
                    {id: 3, name: '限时特惠'},
                    {id: 4, name: '新流程'},
                    {id: 5, name: '老流程'},
                    {id: 6, name: '异业合作'},
                    {id: 7, name: '微信菜单'},
                    {id: 8, name: '乐离活动'},
                    {id: 9, name: '新关注弹出'},
                    {id: 10, name: '微信图文'},
                    {id: 11, name: '新用户清洗'},
                    {id: 12, name: '商务合作'},
                    {id: 13, name: '推文'},
                    {id: 14, name: '社群'},
                    {id: 15, name: '红包'},
                    {id: 16, name: '包装杂志'},
                    {id: 17, name: '小程序'},
                    {id: 18, name: '小奶童'},
                    {id: 19, name: '日常转化'},
                    {id: 20, name: '新品物料'},
                    {id: 21, name: '短信'},
                    {id: 23, name: '秒杀'},
                    {id: 25, name: 'hifive全国'},
                    {id: 26, name: '请酸奶'},
                    {id: 27, name: '图片传播'},
                    {id: 28, name: '生鲜开城'},
                    {id: 29, name: '会员活动'},
                    {id: 30, name: '优惠券直接兑换'},
                    {id: 31, name: '新渠道'},
                    {id: 32, name: '拉新'},
                    {id: 33, name: '非实物'},
                    {id: 34, name: '留存'}],
            }

        },
        //props:['activeParam'],
        //挂载时候执行
        mounted(){
            this.getEnableKeyworldList();
            console.log(this.active);
            this.getCityList();
            this.getActiveTypeList();
            if (this.active.activeNo != '') {
                this.getActiveMethod();
            }
        },
        computed: {},
        methods: {
            getActiveTypeList(){
                getValidDictionaryList({
                    "platformGroupId": 1000, "dictionaryTypeId": 203, "currentPage": 1,
                    "pageSize": 50,
                }).then((res) => {
                    if (res.data.status == 200) {
                        this.loading = false;
                        this.activeTypeList = [];
                        for (let v of res.data.value.list) {
                            let type = {};
                            type.id = parseInt(v.dictionaryKey);
                            type.name = v.dictionaryName;
                            this.activeTypeList.push(type);
                        }
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            getActiveMethod(){
                let that = this;
                getActive({activeNo: that.active.activeNo}).then(res => {
                    that.active = res.data.value
                    console.log('查询活动属性')
//                    if (that.active.activeType == 22) {
//                        that.activeProperty.propertyValue = that.active.categoryId;
//                    }
//                    if (that.active.activeType == 15) {
//                        that.cashTakeTypeProperty.propertyValue = that.active.propertyList[0].propertyValue;
//                        that.cashTakeTypeProperty.propertyId = that.active.propertyList[0].propertyId
//                        that.cashTakeTypeProperty.bindCode = that.active.propertyList[0].bindCode
//                        that.cashTakeTypeProperty.propertyKey = that.active.propertyList[0].propertyKey
//                        that.cashTakeTypeProperty.propertyName = that.active.propertyList[0].propertyName
//                        that.cashTakeTypeProperty.propertyRemark = that.active.propertyList[0].propertyRemark
//                        that.cashTakeTypeProperty.status = that.active.propertyList[0].status
//                        console.log('查询活动属性')
//                        console.log(JSON.stringify(that.active.cashTakeTypeProperty))
//                    }
                    that.changeActiveType(that.active.activeType);
                    if (that.active.parentBindCode != null) {
                        that.initActiveListByBindCode(that.active.parentBindCode)
                    }
                })
            },
            initActiveList(activeName){
                this.activeForm.activeName = activeName;
                this.activeForm.activeType = 47
                this.activeList = [];
                getActiveList(this.activeForm).then((res) => {
                    console.log(res.data.value.list)
                    this.activeList = res.data.value.list;
                })
            },
            initActiveListByBindCode(bindCode){
                this.activeForm.bindCode = bindCode;
                //this.activeForm.activeType=47
                this.activeList = [];
                getActiveList(this.activeForm).then((res) => {
                    console.log(res.data.value.list)
                    this.activeList = res.data.value.list;
                })
            },
            changeCategoryId(newValue){
                this.activeProperty.propertyValue = newValue;
            },
            addActive(){
                //添加活动
                this.active.activeNo = '';
                this.getCityList();
                this.getEnableKeyworldList();
                this.active = {
                    activeNo: '',
                    activeName: '',
                    tjType: 1,
                    deptId: 9,
                    status: 0,
                    beginTime: '',
                    endTime: '',
                    createTime: '',
                    payamount: 0,
                    bindCode: '',
                    activeType: 0,
                    cityId: 0,
                    keywordId: 0,
                    payKeywordId: 0,
                    paySmskeywordId: 0,
                    vipRightType: '',
                    platformId: 1,
                    platformGroupId: 1000,
                    inviteNum: 0,
                    joinNum: 0,
                    isPeriod: 0,
                    remark: '',
                    countdown: 0,
                    parentBindCode: ''
                };
            },
            editeActive(row){
                this.getCityList();
                this.getEnableKeyworldList();
                this.showDialog = true;
                this.active.activeNo = row.activeNo;
                this.active.bindCode = row.bindCode;
                this.active.activeName = row.activeName;
                this.active.tjType = row.tjType;
                this.active.deptId = row.deptId;
                this.active.status = row.status;
                this.active.beginTime = row.beginTime;
                this.active.endTime = row.endTime;
                this.active.payamount = row.payamount;
                this.active.activeType = row.activeType;
                this.active.cityId = row.cityId;
                this.active.keywordId = row.keywordId;
                this.active.payKeywordId = row.payKeywordId;
                this.active.paySmskeywordId = row.paySmskeywordId;
                this.active.vipRightType = row.vipRightType;
                this.active.platformId = 1;
                this.active.platformGroupId = 1000;
                this.active.inviteNum = row.inviteNum;
                this.active.joinNum = row.joinNum;
                this.active.isPeriod = row.isPeriod;
                this.active.remark = row.remark;
                this.active.countdown = row.countdown
                this.active.parentBindCode = row.parentBindCode
//                if (row.activeType == 22) {
//                    this.activeProperty.propertyValue = row.categoryId;
//                }
//                if (row.activeType == 15) {
//                    this.cashTakeTypeProperty.propertyValue = row.propertyList[0].propertyValue;
//                    this.cashTakeTypeProperty.propertyId = row.propertyList[0].propertyId
//                    this.cashTakeTypeProperty.bindCode = row.propertyList[0].bindCode
//                    this.cashTakeTypeProperty.propertyKey = row.propertyList[0].propertyKey
//                    this.cashTakeTypeProperty.propertyName = row.propertyList[0].propertyName
//                    this.cashTakeTypeProperty.propertyRemark = row.propertyList[0].propertyRemark
//                    this.cashTakeTypeProperty.status = row.propertyList[0].status
//                    console.log('查询活动属性')
//                    console.log(JSON.stringify(this.cashTakeTypeProperty))
//                }
                console.log(row);
                this.changeActiveType(row.activeType);
            },
            getCityList(){
                this.cityList = [];
                getEnableallCityList({"transportType": 1}).then((res) => {
                    if (res.data.status == 200) {
                        this.loading = false;
                        this.cityList = res.data.value;
                        this.cityList.push({'cityId': 0, 'cityName': '全国'});
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            getEnableKeyworldList(){
                //关键字
                getKeywordsOption({platformId: 1}).then((res) => {
                    this.keywordList = res.data.filter(item => (item.type == 'text' || item.type == 'image' || item.type == 'coupon' || item.type == 'news'));
                    this.keywordList.push({'id': 0, 'keyword': '无'});
                });
            },
            changeActiveType(newValue) {
                if (newValue == 1 || newValue == 19 || newValue == 22 || newValue == 2 || newValue == 33 || newValue == 37 || newValue == 38 || newValue === 28 || newValue === 41) {
                    this.showInviteNum = true;
                } else {
                    this.showInviteNum = false;
                }
                if (newValue == 43) {
                    this.showCity = true;
                } else {
                    this.showCity = false;
                }
            },
            saveActiveConfig(formName){
                this.loading = true;
                saveActive(this.active).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.showDialog = false;
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                        //this.getAllActivelist();
                        if (this.active.activeType == 22) {
                            //保存活动属性
                            this.showDialog = true;
                            this.saveActiveProperty(res.data.value);
                        }
                        if (this.active.activeType == 15) {
                            //保存活动属性
                            //this.showDialog = true;
                            this.saveCashProperty(res.data.value);
                        }
                        if (this.active.activeNo == '') {
                            this.active = res.data.value;
                            this.editeActive(this.active);
                        } else {
                            this.active = res.data.value;
                            this.editeActive(this.active);
                        }

                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            editeActive(row){
                this.$router.replace({
                    path: '/active/activetabs',
                    name: 'activetabs',
                    query: {
                        activeNo: row.activeNo,
                        bindCode: row.bindCode,
                        activeName: row.activeName,
                        type: '扫码后',
                        activeType: row.activeType,
                        curTab: "tab1",
                        picType: 15,
                        picFrom: "noReturn"
                    }
                })
            },
            saveActiveProperty(active){
                this.activeProperty.bindCode = active.bindCode;
                saveActivePropertyApi(this.activeProperty).then((res) => {
                    if (res.data.status == 200) {
                        this.showDialog = false;
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            saveCashProperty(active){
                this.cashTakeTypeProperty.bindCode = active.bindCode;
                saveActivePropertyApi(this.cashTakeTypeProperty).then((res) => {
                    if (res.data.status == 200) {

                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/active/activeEdit.vue